import styled from 'styled-components';

import theme from '../../../styles/theme';

export const Container = styled.div`
  border-radius: 10px;
  padding: 7px;
  font-size: 12px;
  color: ${theme.white};
  text-align: center;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || theme.greenDefault};
  width: 100%;
  font-weight: 800;
  height: 32px;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  &:hover {
    filter: opacity(0.9);
  }
`;
